import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../config';


function VerifiedAccount() {
  const [status, setStatus] = useState('Verifying your account...');
  const [isVerified, setIsVerified] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [apiData, setApiData] = useState(null);
  
  const navigate = useNavigate();

  useEffect(() => {
    const getToken = () => {
      const path = window.location.pathname.split('/');
      let token = path[path.length - 1];
      
      if (token === 'verify_account') {
        const params = new URLSearchParams(window.location.search);
        token = params.get('token') || '';
      }
      
      return token;
    };

    const verifyAccount = async () => {
      const token = getToken();
      
      if (!token) {
        setStatus('❌ No verification token found');
        return;
      }

      try {
        const response = await fetch(`${API_BASE_URL}/auth/verify_account/${token}`);
        const data = await response.json();
        
        setApiData(data);
        
        // ✅ THE FIX: Check message content instead of data.success
        const message = data.message || '';
        const lowerMessage = message.toLowerCase();
        
        if (response.ok && (lowerMessage.includes('verified') || 
                            lowerMessage.includes('success') ||
                            lowerMessage.includes('activated'))) {
          
          setStatus(`✅ ${message}`);
          setIsVerified(true);
          
          // Auto-redirect
          setTimeout(() => {
            navigate('/dashboard');
          }, 3000);
          
        } else {
          setStatus(`❌ ${message || 'Verification failed'}`);
        }
        
      } catch (error) {
        setStatus('❌ Network error');
      }
    };

    verifyAccount();
  }, [navigate]);

  // Countdown
  useEffect(() => {
    if (isVerified) {
      const timer = setInterval(() => {
        setCountdown(prev => prev > 0 ? prev - 1 : 0);
      }, 5000);
      return () => clearInterval(timer);
    }
  }, [isVerified]);

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '10px',
        textAlign: 'center',
        maxWidth: '500px',
        width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{
          width: '100px',
          height: '100px',
          background: isVerified ? 
            'linear-gradient(135deg, #4CAF50 0%, #2e7d32 100%)' : 
            (status.includes('❌') ? 
              'linear-gradient(135deg, #f44336 0%, #d32f2f 100%)' :
              'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)'
            ),
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 30px',
          fontSize: '48px',
          color: 'white'
        }}>
          {isVerified ? '✓' : (status.includes('❌') ? '✗' : '⏳')}
        </div>
        
        <h1>{isVerified ? 'Success!' : 'Verification'}</h1>
        <p>{status}</p>
        
        {apiData && (
          <div style={{ 
            background: '#f8f9fa', 
            padding: '10px', 
            borderRadius: '5px',
            marginTop: '20px',
            fontSize: '14px'
          }}>
            <strong>API Response:</strong> {JSON.stringify(apiData)}
          </div>
        )}
        
        <div style={{ marginTop: '30px' }}>
          <button onClick={() => navigate('/')} style={{ marginRight: '15px' }}>
            Home
          </button>
          {isVerified && (
            <button onClick={() => navigate('/')}>
              Dashboard ({countdown}s)
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default VerifiedAccount;